import { Image } from '@change/ds-core-ui/Image';

import { ResponsiveMedia } from '../ResponsiveMedia';

type ImpactImageProps = Readonly<{
	image: string;
	title: string;
	view: 'mobile' | 'desktop';
}>;

export const ImpactImage: React.FC<ImpactImageProps> = ({ image, title, view }) => {
	return (
		<ResponsiveMedia view={view} kind="image">
			<Image
				src={image}
				data-testid="impact-story-image"
				className="h-full w-full rounded-none object-cover md:rounded-lg"
				alt={title}
			/>
		</ResponsiveMedia>
	);
};
